var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RewardReviewOrderLayout',{attrs:{"id":_vm.id,"balance":_vm.balance,"color":_vm.color,"cost":_vm.cost,"image":_vm.image,"isLoading":_vm.isLoading,"title":_vm.title,"type":_vm.type},on:{"onBuyReward":_vm.handleBuyReward}})}
var staticRenderFns = []

export { render, staticRenderFns }